import { get, post } from "@libs:axios";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { CamelCasedPropertiesDeep } from "type-fest";

import { UserBotGetSchema, UserBotsBatchCreateRequest } from "@:openapi";

export interface UserBots {
  GET_ALL_BY_BOT_ID: {
    RequestPath: { botId: string };
    Response: CamelCasedPropertiesDeep<Array<UserBotGetSchema>>;
  };
  BATCH: {
    RequestBody: CamelCasedPropertiesDeep<UserBotsBatchCreateRequest>;
    Response: unknown;
  };
}

export const userBotQueryKey = createQueryKeys("userBot", {
  getAllByBotId: (params: UserBots["GET_ALL_BY_BOT_ID"]["RequestPath"]) => [
    params,
  ],
});

export const useQueryGetAllUserBotsByBotId = (
  params: UserBots["GET_ALL_BY_BOT_ID"]["RequestPath"],
  options?: Omit<
    UseQueryOptions<UserBots["GET_ALL_BY_BOT_ID"]["Response"], AxiosError>,
    "queryKey"
  >,
) => {
  return useQuery<UserBots["GET_ALL_BY_BOT_ID"]["Response"], AxiosError>({
    queryKey: userBotQueryKey.getAllByBotId(params).queryKey,
    queryFn: () => {
      return get<UserBots["GET_ALL_BY_BOT_ID"]["Response"]>(
        `/api/user_bots/${params.botId}`,
      );
    },
    ...options,
  });
};

export const useMutationInsertDeleteUserBots = (
  options?: UseMutationOptions<
    UserBots["BATCH"]["Response"],
    AxiosError,
    UserBots["BATCH"]["RequestBody"]
  >,
) => {
  return useMutation({
    mutationFn: (data: UserBots["BATCH"]["RequestBody"]) => {
      return post<UserBots["BATCH"]["Response"]>(`/api/user_bots/batch`, data);
    },
    ...options,
  });
};
